module.exports = __webpack_public_path__ + "img/icons8-codepen.4455d8dd.svg";